import CCOHome from './ccoHomepage.json';

export default [CCOHome];
